import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, endDate, filters) => {
        const params = {
            ci_class: filters.ciClass.join(','),
            operable: filters.operable,
            state:    filters.state
        };

        if (filters.state === 'all') {
            Object.assign(params, {
                start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
                end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
            });
        }

        return params;
    },
    ...storeModuleFactory({
        name:               'monitoringEvents',
        endpoint:           endpoints.monitoring.events,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => item
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/monitoringEvents.js